import { forceRefreshApp } from "../../utils/staleClientRecovery";

export default function StaleClientPrompt({ compact = false }) {
  return (
    <div className={`stale-client-prompt${compact ? " stale-client-prompt--compact" : ""}`} role="alert">
      <h2 className="stale-client-prompt__title">Update needed</h2>
      <p className="stale-client-prompt__body">
        A newer version of Nema Care is available. Tap <strong>Refresh now</strong> to continue—you do not
        need to clear your browser cache manually.
      </p>
      <button type="button" className="stale-client-prompt__btn" onClick={() => forceRefreshApp()}>
        Refresh now
      </button>
    </div>
  );
}
